import { IPagedQuery, IPagedQueryS } from '../components/paginate';
import * as actionTypeProfile from '../action/profile';
import { UploadRelationType } from '../enums/UploadRelationType';
import { IAction } from '../../models/action/core.d';
import { boolean } from 'yup';
export interface IPageProps {
    history?: any;
    location?: any;
    match?: any;
    dispatch?: any;
}

export interface IAddedActivityFileView {
    id: string;
    fileName: string;
    contentType: string;
    filePath: string;
    s3FileSize: number;
    activityId: string;
    activityName: string;
    parentCourseId: string;
    week: string;
    createdDate: string;
    uploadRelationType: UploadRelationType;
    fullName: string | null;
}

export interface IAddedAssignmentFileView {
    id: string;
    fileName: string;
    contentType: string;
    filePath: string;
    s3FileSize: number;
    activityId: string;
    activityName: string;
    parentCourseId: string;
    week: string;
    createdDate: string;
    uploadRelationType: UploadRelationType;
    fullName: string | null;
}

export interface IDeletedFileView {
    id: string;
    fileName: string;
    contentType: string;
    filePath: string;
    s3FileSize: number;
    activityId: string;
    activityName: string;
    parentCourseId: string;
    week: string;
    createdDate: string;
    uploadRelationType: UploadRelationType;
    fullName: string | null;
}

export interface IAddedActivityFileListPageProps extends IPageProps {
    results?: IAddedActivityFileView[];
    filters?: IPagedQuery;
    coursePageClassId?: string;
    userPreferences?: actionTypeProfile.IPreference[];
    userType?: any;
    routerLocation?: any;
}

export interface IAddedActivityFileListPageState {
    filters: IPagedQueryS;
    all_ids: Array<any>;
    selected_ids: Array<any>;
    goToTermListPage: boolean;
    termId: string;
    termName: string;
    filterInitialValues: any;
    unselected_ids?: Array<any>;
    loading: boolean;
}

export interface IAssigmentFileListPageProps extends IPageProps {
    results?: IAddedAssignmentFileView[];
    filters?: IPagedQuery;
    coursePageClassId?: string;
    userPreferences?: actionTypeProfile.IPreference[];
    userType?: any;
    routerLocation?: any;
}

export interface IAssigmentFileListPageState {
    filters: IPagedQueryS;
    all_ids: Array<any>;
    selected_ids: Array<any>;
    goToTermListPage: boolean;
    termId: string;
    termName: string;
    filterInitialValues: any;
    unselected_ids?: Array<any>;
    loading: boolean;
}

export interface IDeletedFileListPageProps extends IPageProps {
    results?: IDeletedFileView[];
    filters?: IPagedQuery;
    coursePageClassId?: string;
    userPreferences?: actionTypeProfile.IPreference[];
    userType?: any;
    routerLocation?: any;
}

export interface IDeletedFileListPageState {
    filters: IPagedQueryS;
    all_ids: Array<any>;
    selected_ids: Array<any>;
    goToTermListPage: boolean;
    termId: string;
    termName: string;
    filterInitialValues: any;
    loading: boolean;
}

export interface IFileListPageProps extends IPageProps {
    results?: IAddedActivityFileView[];
    userPreferences?: actionTypeProfile.IPreference[];
    userType?: any;
    activityFilesStatisticsByTerm?: Array<any>;
}

export interface IFileListPageState {
    goToTermListPage: boolean;
    termId: string;
    termName: string;
    tab: string
}

export interface IActivityFilesListByTermSetAction extends IAction {
    activityFilesListByTerm: {
        results: Array<IAddedActivityFileView> | null;
        filters: IPagedQuery | null;
        tabName: string | null;
    }
}

export const AddedActivityFileInitialValues: IAddedActivityFileView = {
    id: '',
    fileName: '',
    contentType: '',
    filePath: '',
    s3FileSize: 0,
    activityId: '',
    activityName: '',
    parentCourseId: '',
    week: '',
    createdDate: '',
    uploadRelationType: 0,
    fullName: ''
};

export const FilterInitialValues: IPagedQueryS = {
    orderBy: '',
    page: 1,
    take: 10,
    query: '',
    skip: 0,
    total: -1
};


export const filters: IPagedQuery =
{
    page: 1,
    skip: 0,
    take: 10,
    query: null,
    orderBy: "CreatedDate_ASC",
    total: 44
};
